import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="footer-container">
        <div className="footer-content">
          <div className="footer-column footer-about">
            <h4 className="footer-logo">Securtech</h4>
            <p className="footer-text">
              Securtech Lab delivers the best cybersecurity training courses. We specialize in certified ethical hacking courses, bug bounty courses, and CEH v13 ethical hacker courses. We are an official EC Council training partner in Indore. Elevate your skills through hands-on learning, recognized certifications, and expert guidance. Learn cyber security and ethical hacking today.
            </p>
            <div className="social-icons">
              {/* Social media icons can be added here */}
            </div>
          </div>

          <div className="footer-column footer-links">
            <h5 className="footer-heading">Useful Links</h5>
            <ul className="footer-list">
              <li><a href="#">Home</a></li>
              <li><a href="#">About Us</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Blogs</a></li>
            </ul>
          </div>

          <div className="footer-column footer-courses">
            <h5 className="footer-heading">Courses</h5>
            <ul className="footer-list">
              <li><a href="#">Cyber Security</a></li>
              <li><a href="#">Ethical Hacking</a></li>
              <li><a href="#">CEH v13</a></li>
              <li><a href="#">Bug Bounty</a></li>
            </ul>
          </div>

          <div className="footer-column footer-contact">
            <h5 className="footer-heading">Contact Information</h5>
            <p>Near  Tower Square Indore</p>
            <p>securtech.in@gmail.com</p>
            <a  id="instaid" href="https://www.instagram.com/securtech.indore?igsh=cTltMzJpbXMzaHpv">https://www.instagram.com</a>
            <p>+918827055967</p>
            <p>+91 731-4045874</p>
             <p> +91 74008 79303</p>
             <p> +91 7223022165</p>
          </div>


        </div>

        <div className="footer-bottom">
          <p>© 2025 All Right Reserved Securtech</p>
          <p>Website Crafted By <a href="#" className="crafted-by">Duguu</a></p>
          <div className="footer-legal-links">
            <a href="#">Privacy Policy</a> | <a href="#">Responsible Disclosure Policy</a>
          </div>
        </div>
      </footer>

      <style>
        {`
        /* New Global and Font Styles */
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        body {
            font-family: 'Inter', sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f8f9fa;
        }

        /* Footer Styles */
        .footer-container {
            background-color: #6b1e6e;
            color: #b0b0b0;
            padding: 4rem 2rem 1rem;
            font-family: 'Inter', sans-serif;
        }

        .footer-content {
            max-width: 1200px;
            margin: 0 auto;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 2rem;
        }

        .footer-column {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }

        .footer-logo {
            font-size: 2rem;
            font-weight: 700;
            color: #ffffff;
            margin-bottom: 1rem;
        }

        .footer-text {
            font-size: 0.9rem;
            line-height: 1.5;
            color: #888;
        }

        .footer-heading {
            font-size: 1.1rem;
            font-weight: 600;
            color: #ffffff;
            margin-bottom: 0.75rem;
        }

        .footer-list {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        }

        .footer-list a {
            color: #b0b0b0;
            text-decoration: none;
            font-size: 0.9rem;
            transition: color 0.3s ease;
        }

        .footer-list a:hover {
            color: #28a745;
        }

        .footer-bottom {
            max-width: 1200px;
            margin: 2rem auto 0;
            border-top: 1px solid #333;
            padding-top: 1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            font-size: 0.8rem;
            color: #888;
            gap: 1rem;
        }

        .footer-bottom p {
            margin: 0;
        }

        .crafted-by {
            color: #ffffff;
            text-decoration: none;
            font-weight: 600;
        }

        .footer-legal-links a {
            color: #888;
            text-decoration: none;
            margin-right: 1rem;
            transition: color 0.3s ease;
        }

        .footer-legal-links a:hover {
            color: #28a745;
        }

        /* Media Queries for Responsiveness */
        @media (max-width: 768px) {
            .footer-content {
                grid-template-columns: 1fr;
            }

            .footer-bottom {
                flex-direction: column;
                text-align: center;
            }
        }
      `}
      </style>
    </>
  );
};

export default Footer;
